module.exports = __webpack_public_path__ + "img/2.6176056e.svg";